import ClearFilters from './ClearFilters';
import DepartmentsDropdownList from './DepartmentsDropdownList';
import GLCodeDropdownList from './GLCodeDropdownList';
import PeriodDropdownList from './PeriodDropdownList';

const ViewAccrualTableToolbar = () => (
  <div className="flex items-center justify-between w-full">
    <div className="flex items-center gap-1 text-white text-sm">
      <ClearFilters />
      <DepartmentsDropdownList />
      <GLCodeDropdownList />
      <PeriodDropdownList />
    </div>
  </div>
);

export default ViewAccrualTableToolbar;
